module.exports = __webpack_public_path__ + "static/8ad241a3-0d13-42c4-80a7-2bb685cfe5c7-450.f369296d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-michael-and-all-angels/8ad241a3-0d13-42c4-80a7-2bb685cfe5c7-450.jpg
// module id = 1155
// module chunks = 168707334958949